import { Controller } from "@hotwired/stimulus"
import {createCalendar, DayGrid, List} from '@event-calendar/core';

export default class extends Controller {

  connect() {
    this.init();
  }

  isMobile() {
    return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  init() {
    var calendarEl = this.element;
    const isMobile = this.isMobile();
    
    var calendar = createCalendar(calendarEl, [DayGrid, List], {
      view: isMobile ? 'listWeek' : 'dayGridMonth',
      locale: 'hr-HR',
      height: isMobile ? '70vh' : 'auto',
      buttonText: { 
        today: new Date().toLocaleDateString('hr-HR', { day: '2-digit', month: '2-digit', year: '2-digit' }).replace(/\//g, '.'),
        listDay: 'Dan',
        listWeek: 'Tjedan',
        dayGridMonth: 'Mjesec'
      },
      headerToolbar: {
        start: 'title',
        center: 'listDay,listWeek,dayGridMonth',
        end: 'today prev,next'
      },
      date: this.data.get('date') || new Date(),
      eventSources: [
        {
          url: this.data.get('url'),
          method: 'GET',
          failure: function() {
              alert('Dogodio se problem s dohvaćanjem liste događanja!');
          }
        }
      ],
      eventTimeFormat: {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }
    });

    // Handle window resize for responsive behavior
    window.addEventListener('resize', () => {
      const newIsMobile = this.isMobile();
      if (newIsMobile !== isMobile) {
        calendar.setOption('view', newIsMobile ? 'listWeek' : 'dayGridMonth');
        calendar.setOption('height', newIsMobile ? '70vh' : 'auto');
        calendar.setOption('headerToolbar', {
          start: 'title',
          center: 'listDay,listWeek,dayGridMonth',
          end: 'today prev,next'
        });
      }
    });
  }
}
